import React from 'react'

export function TimeRangeInput({ open, close, onChange, onBlur, disabled = false }) {
  return (
    <div className="dome-d-flex dome-align-center dome-gap6">
      <input
        type="time"
        className="form-control"
        style={{ width: 120 }}
        value={open || ''}
        disabled={disabled}
        onBlur={onBlur}
        onChange={(e) => onChange({ open: e.target.value, close })}
      />
      <span className="dome-p2 dome-color-med-grey">to</span>
      <input
        type="time"
        className="form-control"
        style={{ width: 120 }}
        value={close || ''}
        disabled={disabled}
        onBlur={onBlur}
        onChange={(e) => onChange({ open, close: e.target.value })}
      />
    </div>
  )
}
